import React from 'react';
import { AffiliateHeader, AffiliateFooter } from '../components/affiliate/AffiliateChrome';
import { CONTACT_INFO } from '../data/branding';

const TermsPage = () => (
  <div className="min-h-screen bg-neutral-950 text-white">
    <AffiliateHeader />
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-invert prose-headings:font-display prose-headings:tracking-tight">
      <h1>Affiliate Program Terms</h1>
      <p className="text-neutral-400">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
      <h2>Eligibility</h2>
      <p>You must be at least 18 years old and have a lawful traffic source to participate. Approval is at our sole discretion.</p>
      <h2>Affiliate link &amp; subdomain</h2>
      <p>Once approved, you will receive a unique subdomain link of the form <code className="font-mono">https://yourname.axonmuscle.com</code>. You may not impersonate the brand outside this link.</p>
      <h2>Billing descriptor</h2>
      <p>You acknowledge that purchases generated through your link may appear on customer billing statements with a descriptor unique to your affiliate account, and will be visible to customers.</p>
      <h2>Commissions &amp; payouts</h2>
      <p>Commission rate is set on your dashboard at the time of approval and may be adjusted with notice. Payouts are issued via the method you selected, subject to a minimum threshold.</p>
      <h2>Prohibited conduct</h2>
      <ul>
        <li>Self-purchases or fraudulent transactions.</li>
        <li>Spam, malware, deceptive ads, or trademark misuse.</li>
        <li>Promoting our products in regulated industries (e.g. paid search bidding on our brand) without written consent.</li>
      </ul>
      <h2>Termination</h2>
      <p>We may suspend or terminate any account that violates these terms or generates chargebacks above industry norms.</p>
      <h2>Contact</h2>
      <p>Email <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a> for questions about these terms.</p>
    </article>
    <AffiliateFooter />
  </div>
);

export default TermsPage;
